/*
  Таблица «что получится» по строкам реестра - вариант А1 (05.10.2026).

  Устройство «Радара» (решение владельца 22.09.2026): переключатель со счётчиком
  в подписи и одна таблица. Отбор «Требуют вашего внимания» - первым после
  «Все»: ради него человек и открывает таблицу. Решение по строке и его текст
  приходят с сервера - то же, что выполнит запись, второго правила здесь нет.

  Строки - в окне со своей прокруткой (05.10.2026, замечание владельца): двести
  строк иначе уводили итог загрузки на десяток экранов вниз.
*/

import { useState } from 'react'

import { money } from '../api/format.js'
import { Switch, Tag } from './Common.jsx'
import PageBar from './PageBar.jsx'
import usePaging from './usePaging.js'

const ALL = '*'
const ATTENTION = '!'

const ACTION_TAGS = {
  plain: ['calm', 'без отметок'],
  note: ['warn', 'примечание УК'],
  hold: ['warn', 'придержан'],
  case_judged: ['muted', 'взыскано УК'],
  case_open: ['warn', 'дело УК без месяцев'],
}

function pick(rows, value) {
  if (value === ALL) return rows
  if (value === ATTENTION) return rows.filter((row) => row.needs_attention)
  return rows.filter((row) => row.sheet === value)
}

function Row({ row, withSheet }) {
  const [kind, title] = ACTION_TAGS[row.action]
  return (
    <tr>
      <td>
        <b>{row.account_number}</b>
        <div className="muted">{row.address}</div>
      </td>
      <td data-label="Должник">{row.owner_name}</td>
      <td data-label="Что сказала УК">
        <Tag kind={kind}>{title}</Tag>
        {withSheet ? <div className="muted">лист «{row.sheet}»</div> : null}
        {row.note ? <div>{row.note}</div> : null}
      </td>
      <td className="table__block" data-label="Что сделаем">
        <span className="muted">{row.explanation}</span>
      </td>
      <td className="table__num" data-label="Долг по расчёту УК">
        {row.debt_declared ? <b>{money(row.debt_declared)}</b> : <span className="muted">-</span>}
      </td>
    </tr>
  )
}

/*
  Таблица одного отбора с общей панелью страниц (21.10.2026, замечание владельца:
  «пагинация и количество записей в любой список»). Вынесена отдельным компонентом
  ради ключа: страница сбрасывается вместе со сменой отбора - `RegistryRows` отдаёт
  ей `key={shown}`, - а не остаётся на третьей, где нового отбора уже может не быть.
*/
function RowsWindow({ rows, withSheet }) {
  const { rows: page, bar } = usePaging(rows)
  return (
    <>
      <div className="table-scroll registry-rows__window">
        <table className="table table--fixed table--registry-rows">
          <thead>
            <tr>
              <th>Счёт</th>
              <th>Должник</th>
              <th>Что сказала УК</th>
              <th>Что сделаем</th>
              <th className="table__num">Долг по расчёту УК</th>
            </tr>
          </thead>
          <tbody>
            {page.map((row) => (
              <Row key={`${row.sheet}-${row.account_number}`} row={row} withSheet={withSheet} />
            ))}
          </tbody>
        </table>
      </div>
      <PageBar {...bar} what="строк" />
    </>
  )
}

export default function RegistryRows({ rows, sheets }) {
  const [shown, setShown] = useState(ALL)
  const several = sheets.length > 1
  if (!several && rows.every((row) => row.action === 'plain')) return null

  const attention = rows.filter((row) => row.needs_attention).length
  const options = [
    { value: ALL, title: `Все ${rows.length}` },
    { value: ATTENTION, title: `Требуют вашего внимания ${attention}` },
    ...(several
      ? sheets
          .filter((sheet) => sheet.accounts > 0)
          .map((sheet) => ({ value: sheet.title, title: `${sheet.title} ${sheet.accounts}` }))
      : []),
  ]
  const visible = pick(rows, shown)

  return (
    <>
      <div className="row registry-switch">
        <Switch value={shown} onChange={setShown} options={options} />
      </div>
      <div className="card">
        <RowsWindow key={shown} rows={visible} withSheet={several} />
        {visible.length ? null : <p className="muted">В этом отборе строк нет.</p>}
      </div>
    </>
  )
}
